export default "/public/dist/fonts/banner-4.svg";